import { inject } from "@angular/core";
import { Router } from "@angular/router";

import { UserContext } from "@app/contexts";

export const adminGuard = (userContext: UserContext = inject(UserContext), router: Router = inject(Router)) => {
  const canActivate: boolean | null = userContext.isConnected && userContext.user && userContext.user.isAdministrator;

  if (!canActivate) {
    router.navigate(['/not-found'], {
      skipLocationChange: true
    });
  }

  return canActivate;
};
